import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const Invoicedetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams(); // Get invoice ID from URL
  const [invoice, setInvoice] = useState({});
  const [vendor, setVendor] = useState({ firstName: '', lastName: '' });
  const [customer, setCustomer] = useState({ firstName: '', lastName: '' });
  const [loading, setLoading] = useState(true);

  // Get logged in user info
  const loggedInUser = JSON.parse(localStorage.getItem('user') || '{}');

  // Determine dashboard path based on user type
  const getDashboardPath = () => {
    if (loggedInUser.user_type === 1) {
      return '/customerdashboard';
    } else if (loggedInUser.user_type === 3) {
      return '/vendordashboard';
    }
    return '/'; // Default fallback
  };

  const getInvoicesPath = () => {
    if (loggedInUser.user_type === 1) {
      return '/invoices';
    } else if (loggedInUser.user_type === 3) {
      return '/vendorinvoices';
    }
    return '/invoices'; // Default fallback
  };

  useEffect(() => {
    // Fetch invoice details from API
    if (id) {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/invoice/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.invoice) {
            setInvoice(data.invoice);
            
            // Fetch vendor info
            if (data.invoice.vendor_id) {
              fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor?vendor_id=${data.invoice.vendor_id}`)
                .then(res => res.json())
                .then(vendorData => {
                  if (vendorData.vendor) {
                    setVendor({
                      firstName: vendorData.vendor.firstName || '',
                      lastName: vendorData.vendor.lastName || '',
                    });
                  }
                });
            }
            
            // Fetch customer info
            if (data.invoice.customer_id) {
              fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer?customer_id=${data.invoice.customer_id}`)
                .then(res => res.json())
                .then(customerData => {
                  if (customerData.customer) {
                    setCustomer({
                      firstName: customerData.customer.firstName || '',
                      lastName: customerData.customer.lastName || '',
                    });
                  }
                  setLoading(false);
                });
            } else {
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
        })
        .catch(err => {
          console.error('Error fetching invoice:', err);
          setLoading(false);
        });
    } else {
      // Fallback to location state if no ID in URL
      const invoiceData = location.state || {};
      setInvoice(invoiceData);
      
      // Fetch vendor info
      if (invoiceData.vendor_id) {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor?vendor_id=${invoiceData.vendor_id}`)
          .then(res => res.json())
          .then(data => {
            if (data.vendor) {
              setVendor({
                firstName: data.vendor.firstName || '',
                lastName: data.vendor.lastName || '',
              });
            }
          });
      }
      
      // Fetch customer info
      if (invoiceData.customer_id) {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer?customer_id=${invoiceData.customer_id}`)
          .then(res => res.json())
          .then(data => {
            if (data.customer) {
              setCustomer({
                firstName: data.customer.firstName || '',
                lastName: data.customer.lastName || '',
              });
            }
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    }
  }, [id, location.state]);

  // Calculate booking fee and grand total
  const serviceTotal = Number(invoice.amount) / 1.1;
  const bookingFee = (serviceTotal * 0.10).toFixed(2);
  const grandTotal = Number(invoice.amount).toFixed(2);

  // Download PDF handler
  const handleDownloadPDF = () => {
    window.print();
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>Loading invoice details...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Invoice Details</h2>
      <div style={styles.card}>
        <div style={styles.details}>
          <p>
            <strong>Invoice ID:</strong> {invoice.id || 'N/A'}
          </p>
          <p>
            <strong>Customer Name:</strong> {customer.firstName} {customer.lastName}
          </p>
          <p>
            <strong>Coach Name:</strong> {vendor.firstName} {vendor.lastName}
          </p>
          <p>
            <strong>Date:</strong>{' '}
            {invoice.date
              ? (() => {
                  const d = new Date(invoice.date);
                  const mm = String(d.getMonth() + 1).padStart(2, '0');
                  const dd = String(d.getDate()).padStart(2, '0');
                  const yyyy = d.getFullYear();
                  return `${mm}/${dd}/${yyyy}`;
                })()
              : 'N/A'}
          </p>
          <p><strong>Start Time:</strong> {invoice.start_time}</p>
          <p><strong>End Time:</strong> {invoice.end_time}</p>
          <p><strong>Service Fee:</strong> ${serviceTotal.toFixed(2)}</p>
          <p><strong>Booking Fee (10%):</strong> ${bookingFee}</p>
          <p><strong>Total:</strong> ${grandTotal}</p>
        </div>
        <div style={{ marginTop: '18px', textAlign: 'center' }}>
          <button style={styles.button} onClick={handleDownloadPDF}>
            Download PDF
          </button>
          <button style={styles.backBtn} onClick={() => navigate(getInvoicesPath())}>
            Back to Invoices
          </button>
        
          {loggedInUser.user_type === 3 && (
            <button
              style={styles.cashOutBtn}
              onClick={() => navigate('/vendorcashout')}
            >
              Cash Out
            </button>
          )}
            <button style={styles.dashboardBtn} onClick={() => navigate(getDashboardPath())}>
            ← Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '500px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '14px',
    boxShadow: '0 1px 8px #e0cfa0',
    padding: '28px 22px 22px 22px',
    minHeight: '220px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    border: '2px solid #e0cfa0',
    position: 'relative',
  },
  details: {
    marginBottom: '18px',
    fontSize: '1.08rem',
    color: '#333',
  },
  button: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    marginRight: '10px',
  },
  backBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginLeft: '10px',
  },
  loading: {
    textAlign: 'center',
    color: '#8d6e36',
    fontSize: '1.2rem',
    marginTop: '40px',
  },
  dashboardBtn: {
    background: '#8d6e36',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8a96e',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginLeft: '10px',
    marginTop: '10px',
    display: 'block',
    width: '200px',
    margin: '10px auto 0 auto',
  },
  cashOutBtn: {
    background: '#1976d2',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #bbdefb',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginLeft: '10px',
    marginTop: '10px',
  },
};

export default Invoicedetails;